import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity, partial } from 'lodash'

import PaintSummary from 'components/PaintSummary'
import PaintColorSwapModal from 'components/PaintColorSwapModal' 

import { getBackVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import PaintFillChooser from 'components/PaintFillChooser'
import InitialsChooser from 'components/InitialsChooser'
import StampChooser from 'components/StampChooser'
import NavWarning from 'containers/NavWarning'
import { TrackedButtonLink } from 'components/Buttons'

export class BackForm extends Component {
  constructor() {
    super();
    this.state = {
      currentPaintFill: null,
    };
  } 

  setCurrentPaintFill(paint) {
    let colorObj = {};
    colorObj.color = paint;
    if(!paint)
      colorObj = paint;
    this.setState({currentPaintFill: colorObj});
  }

  componentWillMount(){
    this.props.selectView('BC') 
  }
  render = () => (<div>
    <div className="customize-form-header">Back</div>
	  {this.props.paintFillLocations.length === 0 && this.props.initials.length === 0 && this.props.stampsLocations.length === 0 &&
      <div className="customize-form-section">
        <div className="instructional-text">
          There are no customization options on this view.
        </div>
      </div>
    }
    <div className="customize-form-section">
      {this.props.paintFillLocations.length > 0 && 
        <div className="customize-form-section-header">Select Colors</div>
      }
      {/*If paintFill id is not 6 (new paintfill) then link them back to finish to select a customize color option*/}
      {this.props.paintFillLocations.length > 0 && this.props.paintFill.id !== 6 &&
        <div className="customize-form-section-content">
          <div className="enable-paintfill-question">Did you want to customize your colors?</div>
          <div className="enable-paintfill-link" type="button" onClick={() => this.props.onEnablePaintFill('paintFill', 6)}>
            Enable Paintfill
            {!(this.props.buyAPutter && this.props.buyAPutter.selected) && 
              <span> ${this.props.paintFillPrice}</span>
            }
          </div>
          <div className="clearfix"></div>
        </div>
      }
      {this.props.paintFillLocations.length > 0 && this.props.paintFill.id === 6 &&
        <div className="customize-form-section-content">
          <div className="paintfill-tools"> 
            <PaintSummary 
              paints={this.props.paintSummary} 
              maxPaintfillColors={this.props.maxPaintfillColors} 
              onClick={ (paint) => this.setCurrentPaintFill(paint) }/>
            <div className="reset-colors-link" type="button" onClick={() => this.props.resetPaintFills()}>
              Reset to Original
            </div>
            <div className="reset-colors-link" type="button" onClick={() => this.props.clearPaintFills()}>
              Clear All
            </div>
          </div>
          {
            this.props.paintFillLocations.map((loc, index) => (
              <PaintFillChooser key={loc.loc.id}
                loc={loc.loc}
                paints={loc.paints}
                selectedPaint={loc.selected}
                isError={this.props.showValidationWarnings && !loc.valid}
                onSelectPaintFill={(paint) => this.props.onSelectPaintFill(loc.loc.id, paint.id)}
              />
            ))
          }
          <div className="clearfix"></div>
        </div>
      }
    </div>
    <div className="customize-form-section">
      {this.props.initials.length > 0 && 
        <div className="customize-form-section-header">Select Initials</div>
      }
      {this.props.initials.length > 0 && 
        <div className="customize-form-section-content">
          {
            this.props.initials.map(i => (
              <InitialsChooser key={i.loc.id}
				id={i.loc.id}
                initials={i.loc}
                selected={i.selected}
                personalizationStyles={i.styleOptions.filter(style => !style.faceToeOnly)}
                paintLoc={i.paint.loc}
                paints={i.paint.paints}
                selectedPaint={i.paint.selected}
                isError={this.props.showValidationWarnings && !i.valid}
                isPaintError={this.props.showValidationWarnings && !i.paint.valid}
                onFieldChange={partial(this.props.onInitialsFieldChange, i.loc.label)}
                onSelectPaintFill={(locid, paintid) => this.props.onSelectPaintFill(locid, paintid)}
                allowSpaces={true}
              />
            ))
          }
        </div>
      }
    </div>
    <div className="customize-form-section">
      {this.props.stampsLocations.length > 0 && 
        <div className="customize-form-section-header">Select Stamps</div>
      }
      {this.props.stampsLocations.length > 0 && 
        <div className="customize-form-section-content">
          {
            this.props.stampsLocations.map(i => (
              <StampChooser key={i.loc.id}
                stampLoc={i.loc}
                enabled={i.selected && i.selected.enabled}
                selectedStamp={i.selected && i.selected.stamp}
                stamps={i.stamps}
                onCheck={(value) => this.props.onSelectStamp(i.loc.id, 'enabled', value)}
                onSelectStamp={(value) => this.props.onSelectStamp(i.loc.id, 'stampId', value)}
                paintLoc={i.paint.loc}
                selectedPaint={i.paint.selected}
                paints={i.paint.paints}
                isError={this.props.showValidationWarnings && !i.valid}
                isPaintError={this.props.showValidationWarnings && !i.paint.valid}
                onSelectPaintFill={(locid, paintid) => this.props.onSelectPaintFill(locid, paintid)}
              />
            ))
          }
        </div>
      }
    </div>
    <div className="customize-form-section">
      <TrackedButtonLink trackingData="Next:Top" className="next" to="top">next: top</TrackedButtonLink>
    </div>
    <NavWarning when={!this.props.validation.valid}
      message="Please complete all selections above before going to another page." />
    <PaintColorSwapModal 
      headerTitle="Change Color"
      headerText="If you select a new color here, we will apply that color to all the areas that have this color currently selected."
      colorSelectedText="Current Color"
      colorToSelectText="Select a new color:"
      currentPaintFill={this.state.currentPaintFill}
      allPaintColors={this.props.allPaintColors}
      replacePaint={this.props.replacePaint}
      cancel={() => this.setCurrentPaintFill(null)}
      className="paint-swapper"
      paintSwapValid={this.props.paintSwapValid}
    />
  </div>)
}

BackForm.defaultProps = {
  paintFillLocations: [],
  initials: [],
  stampsLocations: [],
  onSelectPaintFill: identity,
  onSelectStamp: identity,
  onInitialsFieldChange: identity,
  onEnablePaintFill: identity,
};

const mapStateToProps = (state, ownProps) => {
  var p = { ...getBackVM(state.customize, false) }
  p.showValidationWarnings = state.app.blockedNavigation && !p.validation.valid
  return p;
}
const mapDispatchToProps = {
  onSelectPaintFill: actions.selectPaintFill,
  onInitialsFieldChange: actions.changeInitials,
  onSelectStamp: actions.selectStamp,
  selectView: actions.selectView,
  onEnablePaintFill: actions.selectField,
  replacePaint: actions.replacePaint,
  resetPaintFills: actions.resetPaintFills,
  clearPaintFills: actions.clearPaintFills,
}

export default connect(mapStateToProps, mapDispatchToProps)(BackForm);
